import { Component, OnInit, ViewChild } from '@angular/core';
import { Context } from '../../../Services/context.service';
import * as models from '../../../Models/projektDB.models'
import { SelectItem } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import { CalendarModule } from 'primeng';
import { CheckboxModule } from 'primeng/checkbox';
 
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-test',
  templateUrl: './projectlist.component.html',
  styles: [
  ]
})
export class ProjectListComponent implements OnInit {

  @ViewChild('calEndDate')
  calendarEndDate: any;

  @ViewChild('tabview')
  tabview: any;

  projectType: string;
  projectTopics: SelectItem[];
  projectStrategyFocus: SelectItem[];
  projectResponsible: SelectItem[];
  projectPartnerRegion: SelectItem[];
  projectCategory: SelectItem[];
  projectSelectionCriteria: SelectItem[];
  projectInterregPeriode: SelectItem[];
  projectApplicantStatus: SelectItem[];
  projectApplicantRegion: SelectItem[];
  projects: models.projekt[];
  projectTitle: string;
  projectTypeEnum: typeof models.ProjectType = models.ProjectType;

  selectedProjectLink: models.projectLink = new models.projectLink;
  selectedProjectVideo: models.projectVideo = new models.projectVideo;

  showEditor: boolean = false;
  showUpload: boolean = false;
  showLinkEditor: boolean = false;
  showVideo: boolean = false;
  inputIsValid: boolean = true;
  showInputIBK: boolean = false;
  showInputKP: boolean = false;
  spinner2: boolean = false;
  newProject: boolean = false;

  uploadProjectFiles: any[] = [];
  uploadBaseURL: string = "/projectDb/api/admin/upload/"; 
  uploadURL: string;

  selectedProjectLinks: models.projectLink[];
  selectedProjectFiles: models.projectFiles[];
  selectedProjectVideos: models.projectVideo[];
  selectedProject: models.projekt = new models.projekt;
  selectedProjectTopic: string[] = [];
  selectedProjectStrategyFocus: string[] = [];
  selectedProjectResposible: string;
  selectedProjectPartnerRegion: string[] = [];
  selectedprojectSelectionCriteria: string[] = [];
  selectedprojectApplicantStatus: string[] = [];
  selectedprojectApplicantRegion: string[] = [];
  selectedprojectInterregPeriode: string[] = [];

  indexTabView: number = 0;

  constructor(public context: Context, private confirmationService: ConfirmationService, private route: ActivatedRoute,
    private router: Router) {

  }

  ngOnInit(): void {
    this.InitProject();
    this.initProjectList();
  }

  // Projekt Typ init
  InitProject(): void {
    switch (this.router.url) {
      case "/home/kpprojects": {     
        this.projectType = models.ProjectType.KP;
        this.showInputIBK = false;
        this.showInputKP = true;
        break;
      }
      case "/home/ibkprojects": {
        this.projectType = models.ProjectType.IBK;
        this.showInputIBK = true;
        this.showInputKP = false;
        break;
      }
      default: {
        this.projectType = models.ProjectType.IBK;
        this.showInputIBK = true;
        this.showInputKP = false;
        break;
      }
    } 
  }

  hasData(value: string): boolean {

    if (value == null) { return false }
    if (value.length > 0) { return true }
    return false
  }

  hasData2(value: any): boolean {

    if (value == null) { return false }
    return true
  }

  isValidInput() {

    if (this.hasData(this.selectedProject.ProjectId) && this.hasData(this.selectedProject.ProjectName) && this.hasData2(this.selectedProject.StartDate)) {
      return true
    } else {
      return false
    }
  }

  // Projectliste init
  initProjectList(): void {
    this.context.api.showSpinner();
    this.loadProjects();
    this.loadInputSelectValues();
    //this.context.api.hideSpinner();
  }

  onChangeTab(e) {
    this.showUpload = false;
    this.showLinkEditor = false;
    this.showVideo = false;
}

  // Projekte laden
  loadProjects(): void {
    this.context.api.showSpinner();
    this.spinner2 = true;
    if (this.projectType == "ibk") {
      this.context.api.getIBKProjects().then(projects => { this.spinner2 = false;this.context.api.hideSpinner(); this.projects = projects });
    } else {
      this.context.api.getKPProjects().then(projects => { this.spinner2 = false;this.context.api.hideSpinner();this.projects = projects });
    }
    //this.context.api.hideSpinner();
  }

  // Auswahloptionen laden
  loadInputSelectValues(): void {
    this.selectedProjectTopic = [];
    this.selectedProjectStrategyFocus = [];
    this.context.api.getTopics().then(topics => this.projectTopics = topics);
    this.context.api.getStrategyFocus().then(strategyFocus => this.projectStrategyFocus = strategyFocus);
    this.context.api.getResponsible().then(responsible => this.projectResponsible = responsible);
    this.context.api.getPartnerRegions().then(partnerRegions => this.projectPartnerRegion = partnerRegions);
    this.context.api.getSelectionCriteria().then(selectionCriteria => this.projectSelectionCriteria = selectionCriteria);
    this.context.api.getInterregPeriode().then(interredPeriode => this.projectInterregPeriode = interredPeriode);
    this.context.api.getApplicantStatus().then(applicantStatus => this.projectApplicantStatus = applicantStatus);
    this.context.api.getApplicantRegion().then(applicantRegion => this.projectApplicantRegion = applicantRegion);
    this.context.api.getCategory().then(category => this.projectCategory = category);
    this.context.api.getPartnerRegions().then(partnerregions => this.projectPartnerRegion = partnerregions);
  }

  // Medien laden
  loadProjectFiles(): void {
    this.context.api.getProjectFiles(this.selectedProject.pId).then(files => {
      this.selectedProjectFiles = files;
    });

  }

  goo(event: any): void {
    debugger
  }

  loadProjectLinks(): void {

    this.context.api.getProjectLinks(this.selectedProject.pId).then(links => {
      this.selectedProjectLinks = links;
    });
  }

  loadProjectVideos(): void {
    this.context.api.getProjectVideos(this.selectedProject.pId).then(videos => {
      this.selectedProjectVideos = videos;
    });
  }

  saveProjectFilesEdited(event): void {
    debugger

    this.context.api.saveFile(event.data).then(() => {
      this.loadProjectFiles()
    });
  }


  saveProjectLink(): void {
    this.selectedProjectLink.pId = this.selectedProject.pId;
    this.selectedProjectLink.PartnerRegion = this.selectedProjectPartnerRegion.join(",");

    if (this.selectedProjectLink.lId == '') {
      this.selectedProjectLink.lId = 'new-link';
    }

    this.context.api.saveLink(this.selectedProjectLink).then(() => {
      this.loadProjectLinks();
    });

    this.selectedProjectLink = new models.projectLink;
    this.selectedProjectPartnerRegion = [];
  }
   
  deleteLink(): void {
    this.context.api.deleteProjectLink(this.selectedProjectLink).then(() => {
      this.loadProjectLinks();
      this.showLinkEditor = false;
      this.selectedProjectLink = new models.projectLink;
    });
  }

  editLink(link: models.projectLink): void {
    this.showLinkEditor = true;
    this.selectedProjectLink = { ...link };
    this.selectedProjectPartnerRegion = this.selectedProjectLink.PartnerRegion.split(",");
  }

  cancelLink(): void {
    this.showLinkEditor = false;
  }


  saveVideoEmbedCode(): void {

    if (this.selectedProjectVideo.pId == "") {
      this.selectedProjectVideo.pId = this.selectedProject.pId;
    }

    if (this.selectedProjectVideo.vId == "") {
      this.selectedProjectVideo.vId = "new-video";
    }

    this.context.api.saveVideo(this.selectedProjectVideo).then(() => {
      this.loadProjectVideos();
      this.showVideo = false;
      this.selectedProjectVideo = new models.projectVideo;
    })
  }

  // Select Felder Initialisieren
  initInputSelectFieldsSelectValues(): void {
    this.selectedProjectTopic = [];
    this.selectedProjectStrategyFocus = [];
  }


  // Projekt bearbeiten
  editProject(project: models.projekt): void {
    this.newProject = false;
    this.indexTabView = 0;
    this.projectTitle = "Projekt bearbeiten";

    this.initInputSelectFieldsSelectValues();

    if (project.Topic) {
      this.selectedProjectTopic = project.Topic.split(",");
    }

    if (project.StrategyFocus) {
      this.selectedProjectStrategyFocus = project.StrategyFocus.split(",");
    }

    if (project.SelectionCriteria) {
      this.selectedprojectSelectionCriteria = project.SelectionCriteria.split(",");
    }


    this.selectedProject = { ...project };
    this.loadProjectFiles();
    this.loadProjectVideos();

    if (this.projectType == models.ProjectType.KP) {
      this.loadProjectLinks();
    }

    // Kalender End Datum wenn kein Datum gesetzt wurde
    if (new Date(this.selectedProject.EndDate).getFullYear() == new Date('1900-01-01').getFullYear()) {
      this.calendarEndDate.value = null;
      this.selectedProject.EndDate = null;
    } else {
      this.selectedProject.EndDate = new Date(this.selectedProject.EndDate);
    }

    // Kalender Startdatum


    this.selectedProject.StartDate = new Date(this.selectedProject.StartDate);

    this.showEditor = true;

    this.uploadURL = this.uploadBaseURL + this.selectedProject.pId;
  }


  showhideUpload(): void {
    this.showVideo = false;
    this.showUpload ? this.showUpload = false : this.showUpload = true;
  }

  showhideLinkEditor(): void {
    this.showLinkEditor ? this.showLinkEditor = false : this.showLinkEditor = true;
  }

  showhideVideo(): void {
    this.showUpload = false;
    this.showVideo ? this.showVideo = false : this.showVideo = true;
  }

  // Upload erledigt
  uploadDone(): void {
    this.loadProjectFiles();
  }

  // neues Projekt hinzufügen
  addProject(id: any): void {
    this.newProject = true;
    this.projectTitle = "Neues Projekt hinzufügen";
    this.initInputSelectFieldsSelectValues();
    this.selectedProject = new models.projekt;
    this.selectedProject.pId = "new-project";
    this.selectedProject.Type = this.projectType; //'"ibk";
    this.showEditor = true;
    this.tabview.selectTab(0);
    
  }

  removeProjectEndDate(): void {
    this.selectedProject.EndDate = null;
    this.calendarEndDate.value = null;
    this.calendarEndDate.updateInputfield();
  }

  // Projekt speichern
  saveProject(): void {
    debugger
    if (this.selectedProject.EndDate == undefined) {
      this.selectedProject.EndDate = new Date('1900-01-01');
    } else {
      this.selectedProject.EndDate = new Date(this.selectedProject.EndDate.setTime(this.selectedProject.EndDate.getTime() + (1 * 60 * 60 * 1000)))
    }

    this.selectedProject.StartDate = new Date(this.selectedProject.StartDate.setTime(this.selectedProject.StartDate.getTime() + (1 * 60 * 60 * 1000)))

    this.selectedProject.StrategyFocus = this.selectedProjectStrategyFocus.join(",");
    this.selectedProject.Topic = this.selectedProjectTopic.join(",");
    this.selectedProject.SelectionCriteria = this.selectedprojectSelectionCriteria.join(",");

    if (this.projectType === "ibk") {
      this.context.api.saveProject(this.selectedProject);
    } else if(this.projectType === "kp") {
      this.context.api.saveKPProject(this.selectedProject);
    }

    this.showEditor = false;
    this.showUpload = false;
    this.showLinkEditor = false;
    this.loadProjects();
  }

  cancelProject(): void {
    this.showEditor = false;
    this.showUpload = false;
    this.showLinkEditor = false;
  }

  deleteFile(file: models.projectFiles): void {
    this.context.api.deleteProjectFile(file).then(()=> this.loadProjectFiles());
  }

  editVideoEmbedCode(video: models.projectVideo): void {
    this.showVideo = true;
    this.showUpload = false;
    this.selectedProjectVideo = { ...video };
  }

  cancelVideoEmbedCode(): void {
    this.showVideo = false;
    this.selectedProjectVideo = new models.projectVideo;
  }

  deleteVideoEmbedCode(): void {
    this.context.api.deleteProjectVideo(this.selectedProjectVideo).then(() => this.loadProjectVideos());
    this.showhideVideo();
    this.selectedProjectVideo = new models.projectVideo;
  }

  // Projekt löschen
  deleteProject(): void {
    this.confirmationService.confirm({
      header: 'Löschen betsätigen',
      message: 'Dieses Projekt löschen?',
      accept: () => {
        this.context.api.showSpinner()
        this.context.api.deleteProject(this.selectedProject).then(res => {
          this.loadProjects();
          this.context.api.hideSpinner()
          this.showEditor = false;
          this.showUpload = false;
          this.showLinkEditor = false;
        })       
      }
    });
  }
}
